import React, { useState } from "react";
import TextInputModal from "../../../TextInputModal";
import { LongButton } from "../../../Buttons";
import { GiSave } from "react-icons/gi";
import { AiOutlineDownload } from "react-icons/ai";
import {
  antdMessageError,
  antdMessageSuccess,
  getDateFormat,
  phonenumberValid,
} from "../../../../../helpers/Utils";
import { ClassicButtonOutline } from "../../../ButtonWithLoading";
// import { createPartialInvoice } from "../../../../../redux/Actions/orderAction";
import DalineSaskaita from "./invoice/PopoverInvoiceButton";
import SelectInput from "../../../SelectInput";
import {
  ButtonSecondary,
  DataPickerInput,
  InputSwitchComponent,
  TextInput,
} from "../../../../globals";
import { useForm } from "../../../../../hooks";
import { useDispatch } from "react-redux";
import { addressFromRedux } from "../../../../../redux/Actions/addressAction";
import { updateOrderAddress } from "../../../../../redux/Actions/orderAction";
import { useSelector } from "react-redux";
import { UlElements } from "../../../StyledComponents";

const sanitizeNumeric = (value) => String(value || "").replace(/[\s.]/g, "");
const sanitizePhone = (value) => String(value || "").replace(/[^0-9+]/g, "");

const onChangeNumeric = (onChange) => (e) => {
  onChange({
    ...e,
    target: {
      ...e.target,
      name: e.target.name,
      value: sanitizeNumeric(e.target.value),
    },
  });
};

const onChangePhone = (onChange) => (e) => {
  onChange({
    ...e,
    target: {
      ...e.target,
      name: e.target.name,
      value: sanitizePhone(e.target.value),
    },
  });
};

function BillingAddressComponent({
  disabled,
  billing_address,
  billingAdr_action_edit,
  postToRivile,
  orderId,
  onToggle,
  customAction,
  hideInvoice,
}) {
  const [rivile, setRivile] = useState({ success: false, error: null });

  const postRivile = () => {
    setRivile({ success: "loading", error: rivile.error });
    postToRivile(orderId).then((res) => {
      if (res.success) {
        setRivile({
          success: true,
          error: null,
        });
      } else {
        setRivile({
          success: false,
          error: res.error,
        });
      }
    });
  };

  const phonenumber = phonenumberValid(billing_address.phone);

  if (billingAdr_action_edit) {
    if (!!customAction) {
      return (
        <BillingFormOld
          billing_address={billing_address}
          customAction={customAction}
          UlElements={UlElements}
        />
      );
    }
    return (
      <BillingForm
        orderId={orderId}
        UlElements={UlElements}
        onToggle={onToggle}
      />
    );
  }
  return (
    <React.Fragment>
      <UlElements>
        <li>
          {billing_address.firstname} {billing_address.lastname}
        </li>
        {billing_address.company && <li>{billing_address.company}</li>}
        {billing_address.company_code && (
          <li>{billing_address.company_code}</li>
        )}
        {billing_address.vat_code && <li>PVM: {billing_address.vat_code}</li>}
        <li>{billing_address.street}</li>
        {billing_address.street2 !== null && <li>{billing_address.street2}</li>}
        <li>
          {billing_address?.country && `${billing_address.country.en_name}, `}
          {billing_address.city}, {billing_address.postal_code}
        </li>
        <li className={phonenumber ? "" : "text-danger"}>
          {billing_address.phone}
        </li>
        <li>{billing_address.other}</li>

        {!!postToRivile && (
          <li className="d-flex flex-wrap">
            <div className="mr-3 d-flex mb-1">
              {billing_address.registered_in_rivile ? (
                <div className="d-flex">
                  <LongButton
                    style={{
                      backgroundColor: "#28a745",
                      color: "white",
                      fontSize: "12px",
                      maxWidth: "150px",
                      height: "auto",
                      width: "auto",
                      padding: "0 13px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    text={"Exported"}
                  />
                </div>
              ) : disabled ? null : (
                <ClassicButtonOutline
                  loading={rivile.success == "loading"}
                  onClick={() => postRivile()}
                >
                  <AiOutlineDownload size={16} />
                  <span className="ml-1">Client</span>
                </ClassicButtonOutline>
              )}
            </div>
            {!disabled && !hideInvoice && (
              <>
                <div className="mb-1 mr-3">
                  <DalineSaskaita />
                </div>
                <div className="mb-1 mr-3">
                  <DalineSaskaita mode={"pre_invoice"} />
                </div>
              </>
            )}
          </li>
        )}
        {rivile.error !== null && (
          <li className="text-danger" style={{ fontSize: "13px" }}>
            {rivile.error.map((item) => (
              <div key={item}>{item}</div>
            ))}
          </li>
        )}
      </UlElements>
    </React.Fragment>
  );
}

export const BillingFormOld = ({ customAction, billing_address }) => {
  const { countries } = useSelector((state) => state.options);
  const [errors, setErrors] = useState({});

  const { onChange, form } = useForm({
    billing_address_attributes: billing_address,
  });

  const validate = () => {
    const newErrors = {};
    const addr = form.billing_address_attributes;

    if (!addr.firstname || addr.firstname.trim() === "") {
      newErrors.firstname = ["First name is required"];
    }
    if (!addr.lastname || addr.lastname.trim() === "") {
      newErrors.lastname = ["Last name is required"];
    }
    if (!addr.country_id) {
      newErrors.country_id = ["Country is required"];
    }
    if (!addr.street || addr.street.trim() === "") {
      newErrors.street = ["Address is required"];
    }
    if (!addr.city || addr.city.trim() === "") {
      newErrors.city = ["City is required"];
    }
    if (!addr.postal_code || addr.postal_code.trim() === "") {
      newErrors.postal_code = ["Postal code is required"];
    }
    if (!addr.phone || addr.phone.trim() === "") {
      newErrors.phone = ["Phone is required"];
    } else if (!phonenumberValid(addr.phone)) {
      newErrors.phone = ["Invalid phone number"];
    }
    if (addr.company && (!addr.company_code || addr.company_code.trim() === "")) {
      newErrors.company_code = ["Company code is required when company is provided"];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      customAction(form);
    }
  };

  return (
    <UlElements>
      <li>
        <TextInputModal
          text="First name"
          name="billing_address_attributes[firstname]"
          value={form.billing_address_attributes.firstname}
          onChange={onChange}
          error={errors.firstname}
        />
      </li>
      <li>
        <TextInputModal
          text="Last name"
          name="billing_address_attributes[lastname]"
          value={form.billing_address_attributes.lastname}
          onChange={onChange}
          error={errors.lastname}
        />
      </li>
      <li>
        <SelectInput
          required={true}
          label="Country"
          name="billing_address_attributes[country_id]"
          value={form.billing_address_attributes.country_id}
          onChange={(value) => {
            onChange({
              target: { name: "billing_address_attributes[country_id]", value },
            });
          }}
          options={countries}
          error={errors.country_id}
        />
      </li>
      <li>
        <TextInputModal
          text="Address"
          name="billing_address_attributes[street]"
          value={form.billing_address_attributes.street}
          onChange={onChange}
          error={errors.street}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="City"
          name="billing_address_attributes[city]"
          value={form.billing_address_attributes.city}
          onChange={onChange}
          error={errors.city}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Postal code"
          name="billing_address_attributes[postal_code]"
          value={form.billing_address_attributes.postal_code}
          onChange={onChangeNumeric(onChange)}
          error={errors.postal_code}
        />
      </li>
      <li>
        <TextInputModal
          text="Phone"
          name="billing_address_attributes[phone]"
          value={form.billing_address_attributes.phone}
          onChange={onChangePhone(onChange)}
          error={errors.phone}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Email"
          name="billing_address_attributes[other]"
          value={form.billing_address_attributes.other}
          onChange={onChange}
          error={errors.other}
        />
      </li>
      <li>
        <TextInputModal
          text="Company"
          name="billing_address_attributes[company]"
          value={form.billing_address_attributes.company}
          onChange={onChange}
        />
      </li>
      <li>
        <TextInputModal
          text="Company code"
          name="billing_address_attributes[company_code]"
          value={form.billing_address_attributes.company_code}
          onChange={onChangeNumeric(onChange)}
          error={errors.company_code}
        />
      </li>
      <li>
        <TextInputModal
          text="VAT code"
          name="billing_address_attributes[vat_code]"
          value={form.billing_address_attributes.vat_code}
          onChange={onChangeNumeric(onChange)}
        />
      </li>

      <li className="my-3">
        <ButtonSecondary onClick={handleSubmit}>
          <GiSave />
          {"Update"}
        </ButtonSecondary>
      </li>
    </UlElements>
  );
};

const BillingForm = ({ orderId, UlElements, onToggle }) => {
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.options);
  const { onChange, form } = useForm(dispatch(addressFromRedux()));
  const [errors, setErrors] = useState({});

  const {
    customer: { personal_code, document_number },
  } = useSelector((state) => state.orders.order);

  const validate = () => {
    const newErrors = {};
    const addr = form.billing_address_attributes;

    if (!addr.firstname || addr.firstname.trim() === "") {
      newErrors.firstname = ["First name is required"];
    }
    if (!addr.lastname || addr.lastname.trim() === "") {
      newErrors.lastname = ["Last name is required"];
    }
    if (!addr.country_id) {
      newErrors.country_id = ["Country is required"];
    }
    if (!addr.street || addr.street.trim() === "") {
      newErrors.street = ["Address is required"];
    }
    if (!addr.city || addr.city.trim() === "") {
      newErrors.city = ["City is required"];
    }
    if (!addr.postal_code || addr.postal_code.trim() === "") {
      newErrors.postal_code = ["Postal code is required"];
    }
    if (!addr.phone || addr.phone.trim() === "") {
      newErrors.phone = ["Phone is required"];
    } else if (!phonenumberValid(addr.phone)) {
      newErrors.phone = ["Invalid phone number"];
    }
    if (addr.company && (!addr.company_code || addr.company_code.trim() === "")) {
      newErrors.company_code = ["Company code is required when company is provided"];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validate()) {
      const { ok } = await dispatch(updateOrderAddress(orderId, form));
      if (ok) {
        antdMessageSuccess("Address updated");
        onToggle();
      } else {
        antdMessageError();
      }
    }
  };

  return (
    <UlElements>
      <li>
        <TextInputModal
          text="First name"
          name="billing_address_attributes[firstname]"
          value={form.billing_address_attributes.firstname}
          onChange={onChange}
          error={errors.firstname}
        />
      </li>
      <li>
        <TextInputModal
          text="Last name"
          name="billing_address_attributes[lastname]"
          value={form.billing_address_attributes.lastname}
          onChange={onChange}
          error={errors.lastname}
        />
      </li>
      <li>
        <SelectInput
          required={true}
          label="Country"
          name="billing_address_attributes[country_id]"
          value={form.billing_address_attributes.country_id}
          onChange={(value) => {
            onChange({
              target: { name: "billing_address_attributes[country_id]", value },
            });
          }}
          options={countries}
          error={errors.country_id}
        />
      </li>
      <li>
        <TextInputModal
          text="Address"
          name="billing_address_attributes[street]"
          value={form.billing_address_attributes.street}
          onChange={onChange}
          error={errors.street}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="City"
          name="billing_address_attributes[city]"
          value={form.billing_address_attributes.city}
          onChange={onChange}
          error={errors.city}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Postal code"
          name="billing_address_attributes[postal_code]"
          value={form.billing_address_attributes.postal_code}
          onChange={onChangeNumeric(onChange)}
          error={errors.postal_code}
        />
      </li>
      <li>
        <TextInputModal
          text="Phone"
          name="billing_address_attributes[phone]"
          value={form.billing_address_attributes.phone}
          onChange={onChangePhone(onChange)}
          error={errors.phone}
        />{" "}
      </li>
      <li>
        <TextInputModal
          text="Email"
          name="billing_address_attributes[other]"
          value={form.billing_address_attributes.other}
          onChange={onChange}
          error={errors.other}
        />
      </li>
      <li>
        <TextInputModal
          text="Company"
          name="billing_address_attributes[company]"
          value={form.billing_address_attributes.company}
          onChange={onChange}
        />
      </li>
      <li>
        <TextInputModal
          text="Company code"
          name="billing_address_attributes[company_code]"
          value={form.billing_address_attributes.company_code}
          onChange={onChangeNumeric(onChange)}
          error={errors.company_code}
        />
      </li>
      <li>
        <TextInputModal
          text="VAT code"
          name="billing_address_attributes[vat_code]"
          value={form.billing_address_attributes.vat_code}
          onChange={onChangeNumeric(onChange)}
        />
      </li>
      {/* Customer */}
      <div>
        <DataPickerInput
          text="Birthday"
          name="customer_attributes[birthday]"
          value={getDateFormat(form.customer_attributes.birthday)}
          onChange={(_, ar) =>
            onChange({
              target: { name: "customer_attributes[birthday]", value: ar },
            })
          }
        />
        <TextInput
          text="Personal code"
          subText={personal_code ? "Already saved" : ""}
          name="customer_attributes[personal_code]"
          value={form.customer_attributes.personal_code}
          onChange={onChangeNumeric(onChange)}
        />
        <InputSwitchComponent
          label="Identification method"
          name="customer_attributes[document_type]"
          options={[
            {
              label: "Passport",
              value: "passport",
            },
            {
              label: "ID card",
              value: "id_card",
            },
          ]}
          value={form.customer_attributes.document_type}
          onChange={onChange}
        />
        <TextInput
          text="Pasport number"
          subText={document_number ? "Already saved" : ""}
          name="customer_attributes[document_number]"
          value={form.customer_attributes.document_number}
          onChange={onChangeNumeric(onChange)}
        />
      </div>

      <li className="my-3">
        <ButtonSecondary onClick={handleSubmit}>
          <GiSave />
          {"Update"}
        </ButtonSecondary>
      </li>
    </UlElements>
  );
};

export default BillingAddressComponent;
